import tinytime from 'tinytime';

import { ChartableType, ChartDataPoint } from '@components/ScreenerResults/ScreenerChart/types';
import { compact } from '@components/utils';

const dateOfBirth = tinytime('{DD} {MMMM} {YYYY}');

export const calcData = (type: ChartableType, answers: any[]): ChartDataPoint[] => {
  let resultObj = {};

  switch (type) {
    case 'multiple_choice':
      resultObj = compact(answers).reduce((data, aa) => {
        const answers = Array.isArray(aa) ? aa : [aa];

        answers.forEach((a) => (data[a] = data[a] ? data[a] + 1 : 1));

        return data;
      }, {});
      break;
    case 'number_range':
    case 'single_choice':
    case 'boolean':
    case 'yes_no':
    case 'prototype_test':
    case 'card_sort':
      resultObj = compact(answers).reduce((data, a) => {
        data[a] = data[a] ? data[a] + 1 : 1;
        return data;
      }, {});
      break;
    case 'number':
      resultObj = compact(answers)
        .map((a) => parseInt(a))
        .sort()
        .reduce((data, a) => {
          data[a] = data[a] ? data[a] + 1 : 1;
          return data;
        }, {});
      break;

    case 'datetime':
    case 'date':
      return answers.map((a) => dateOfBirth.render(new Date(a)));

    default:
      return compact(answers);
  }

  return Object.keys(resultObj)
    .map((v) => ({ x: v, y: resultObj[v] }))
    .reverse();
};
